// @flow
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import DatePicker from 'react-datepicker';
import classNames from "classnames";

type DatepickerInputProps = {
    onClick?: PropTypes.func,
    value?: string,
    className?: string
};

export class DatepickerInput extends Component<DatepickerInputProps> {
    constructor(props) {
        super(props);

        this.onDateValueChange = this.onDateValueChange.bind(this);
    }

    onDateValueChange = () => {
    };
    
    render() {
        return (
            <input
                type="text"
                className={classNames('form-control date', this.props.className)}
                id="dash-daterange"
                onClick={this.props.onClick}
                value={this.props.value}
                onChange={this.onDateValueChange}
            />
        );
    }
}

type DatepickerInputWithAddonProps = {
    onClick?: PropTypes.func,
    value?: string,
    className?: string
};

export class DatepickerInputWithAddon extends Component<DatepickerInputWithAddonProps> {
    render() {
        return (
            <div className="input-group">
                <input
                    type="text"
                    className={classNames('form-control', this.props.className)}
                    id="dash-daterange"
                    onClick={this.props.onClick}
                    value={this.props.value}
                    readOnly
                />

                <div className="input-group-append">
                    <span className="input-group-text bg-primary text-white">
                        <i className="mdi mdi-calendar-range sm-icon"></i>
                    </span>
                </div>
            </div>
        );
    }
}

type HyperDatepickerProps = {
    hideAddon?: boolean,
    className?: string
};

type HyperDatepickerState = {
    startDate?: Date,
};

class HyperDatepicker extends Component<HyperDatepickerProps, HyperDatepickerState> {
    constructor(props: HyperDatepickerProps) {
        super(props);
        this.state = {
            startDate: props.startDate,
        };

        this.handleDateSelectChange = this.handleDateSelectChange.bind(this);
    }

    handleDateSelectChange = (date: any) => {
        if (this.props.data) {
            this.props.data(date);
        }

        this.setState({
            startDate: date,
        });
    };

    render() {
        const input = (this.props.hideAddon || false) === true
            ? <DatepickerInput {...this.props}/>
            : <DatepickerInputWithAddon {...this.props}/>;

        const value = this.props.value ? new Date(this.props.value).toLocaleDateString('en-GB') : this.props.value
        const selected = this.props.value ? new Date(this.props.value) : this.props.value
        const startDate = this.props.startDate ? new Date(this.props.startDate) : this.props.startDate
        const endDate = this.props.endDate ? new Date(this.props.endDate) : this.props.endDate
        const minDate = this.props.minDate ? new Date(this.props.minDate) : this.props.minDate
        const maxDate = this.props.maxDate ? new Date(this.props.maxDate) : this.props.maxDate

        return (
            <DatePicker
                {...this.props}
                customInput={input}
                selected={selected}
                onChange={this.handleDateSelectChange}
                value={value}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                maxDate={maxDate}
                showMonthDropdown
                showYearDropdown
            />
        );
    }
}

export default HyperDatepicker;
